import { useState, useEffect } from 'react'
import { API_URL } from '../config/api'
import './ProductDetailModal.css'

function getDescriptionText(desc) {
  if (!desc) return ''
  if (typeof desc === 'string') return desc
  if (Array.isArray(desc))
    return desc.map(b => b.children?.map(c => c.text).join('') || '').join('\n')
  return ''
}

function getImageUrl(image) {
  if (!image) return null
  if (Array.isArray(image.data)) return image.data[0]?.attributes?.url
  return image.data?.attributes?.url || null
}

function getExampleImageUrl(image) {
  if (!image) return null
  const img = image.data || image
  return img?.attributes?.url || img?.url || null
}

export default function ProductDetailModal({ product, minStickerPrice, inCart, onAddToCart, onUpdateQty, onConfigure, onClose }) {
  const attr = product.attributes
  const imgUrl = getImageUrl(attr.image)
  const isCustomizable = !!attr.customizable
  const description = getDescriptionText(attr.description)
  const [quantity, setQuantity] = useState(1)
  const [examples, setExamples] = useState([])
  const [slideIndex, setSlideIndex] = useState(0)

  useEffect(() => {
    if (!isCustomizable) return
    fetch(`${API_URL}/api/sticker-examples?populate=*&sort=order:asc`)
      .then(r => r.json())
      .then(d => setExamples(d.data || []))
      .catch(() => setExamples([]))
  }, [isCustomizable])

  useEffect(() => {
    if (examples.length < 2) return
    const timer = setInterval(() => {
      setSlideIndex(i => (i + 1) % examples.length)
    }, 3000)
    return () => clearInterval(timer)
  }, [examples.length])

  return (
    <div className="pd-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="pd-modal">
        <button className="pd-close" onClick={onClose}>✕</button>

        <div className="pd-body">
          <div className="pd-image-wrap">
            {isCustomizable && examples.length > 0 ? (
              <>
                {examples.map((example, i) => {
                  const exAttrs = example.attributes || example
                  const url = getExampleImageUrl(exAttrs.image)
                  return (
                    <img
                      key={example.id}
                      src={url ? `${API_URL}${url}` : undefined}
                      alt={exAttrs.caption}
                      className={`pd-slide${i === slideIndex ? ' pd-slide--active' : ''}`}
                    />
                  )
                })}
                {examples.length > 1 && (
                  <div className="pd-slide-dots">
                    {examples.map((_, i) => (
                      <button
                        key={i}
                        className={`pd-slide-dot${i === slideIndex ? ' pd-slide-dot--active' : ''}`}
                        onClick={() => setSlideIndex(i)}
                        aria-label={`Voorbeeld ${i + 1}`}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : imgUrl ? (
              <img src={`${API_URL}${imgUrl}`} alt={attr.name} />
            ) : (
              <div className="pd-image-placeholder">🏷️</div>
            )}
            {isCustomizable && <div className="pd-badge">✂️ Die-cut</div>}
          </div>

          <div className="pd-info">
            <h2>{attr.name}</h2>
            <div className="pd-price">
              {isCustomizable
                ? (minStickerPrice != null ? `Vanaf €${minStickerPrice.toFixed(2)}` : 'Vanaf...')
                : `€${(attr.price || 0).toFixed(2)}`}
            </div>

            {description && (
              <p className="pd-description">{description}</p>
            )}

            <div className="pd-cta">
              {isCustomizable ? (
                <button className="btn-configure" onClick={() => { onConfigure(); onClose() }}>
                  🎨 Personaliseren
                </button>
              ) : (
                <>
                  <div className="pd-qty">
                    <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>−</button>
                    <span>{quantity}</span>
                    <button onClick={() => setQuantity(q => q + 1)}>+</button>
                  </div>
                  <button
                    className="btn-add"
                    onClick={() => { onAddToCart(quantity); onClose() }}
                  >
                    + Toevoegen aan winkelwagen
                  </button>
                </>
              )}
            </div>

            {!isCustomizable && inCart && (
              <p className="pd-in-cart-hint">Al {inCart.quantity}× in je winkelwagen</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
